export default __webpack_public_path__ + "static/anzeige-meg-7c53fb21b537a49d0375b81d315b4578.jpg";